// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.

import React from 'react';
import {useIntl} from 'react-intl';

export default function ReplyIcon(props: React.HTMLAttributes<HTMLSpanElement>) {
    const {formatMessage} = useIntl();
    return (
        <span {...props}>
            <svg
                width='16px'
                height='16px'
                viewBox='0 0 24 24'
                role='img'
                aria-label={formatMessage({id: 'generic_icons.reply_in_thread', defaultMessage: 'Discuss message Icon'})}
            >
                <path d='M17 14c.6 0 1-.4 1-1V3c0-.6-.4-1-1-1H3c-.6 0-1 .4-1 1v15l4-4h11Zm-13-.8V4h12v8H5.2L4 13.2ZM21 6h-1v11.2L18.8 16H6v1.2c.1.4.5.8 1 .8h11l4 4V7c0-.6-.4-1-1-1Z'/>
            </svg>
        </span>
    );
}
